
import { Component, Vue, Prop, Getter } from "nuxt-property-decorator";
import { BIcon, BIconColumns, BIconRulers } from "bootstrap-vue";

@Component({ components: { BIcon, BIconColumns, BIconRulers } })
export default class TheBeni extends Vue {
  @Prop() data!: any;
  @Prop() clientMap!: any;
  @Prop() loadMapLazly!: boolean;
  @Getter("preset/currentGenre") currentGenre!: string;
}
